module.exports = __webpack_public_path__ + "img/credit-one-club-gal-7.24375769.jpg";